"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _emotion = require("../../utils/emotion");
var _useCss = _interopRequireDefault(require("../../hooks/useCss.hook"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var BurgerIcon = function BurgerIcon(props) {
  var _props$size = props.size,
    size = _props$size === void 0 ? 4 : _props$size,
    className = props.className;
  var w = size;
  var h = size;
  var r = size / 16;
  var l = r * 3;
  var rootClass = (0, _useCss["default"])(function (theme) {
    return {
      width: theme.size(w),
      height: theme.size(h),
      display: 'flex',
      justifyContent: 'space-evenly',
      alignItems: 'center',
      flexDirection: 'column'
    };
  });
  var lineClass = (0, _useCss["default"])(function (theme) {
    return {
      backgroundColor: 'currentColor',
      width: theme.size(size),
      height: theme.size(l),
      borderRadius: theme.size(r)
    };
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: (0, _emotion.cx)(rootClass, className),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: lineClass
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: lineClass
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: lineClass
    })]
  });
};
var _default = BurgerIcon;
exports["default"] = _default;